import React from 'react';
import { Helmet } from 'react-helmet';
import App from '../components/App';
import { headData } from '../mock/data';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';

export default () => {
    const { title, lang, description } = headData;

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{title || 'Douglas Ryu'}</title>
                <html lang={lang || 'en'} />
                <meta name="description" content={description || 'Gatsby Simplefolio'} />
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/gh/konpa/devicon@master/devicon.min.css"></link>
            </Helmet>
            <App />
        </>
    );
};
